import {
  ImageInput,
  ImageInputProps,
  isEmpty,
  useLiveValidation,
} from '@infotech-soe/erp-ui-kit';
import pick from 'lodash/pick';
import React from 'react';

import { ImageInputFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { InputOnValidate } from './useForm';

interface ImageInputControlProps extends Pick<
  ImageInputProps,
  'onChange' | 'onChanged'
> {
  control: ImageInputFormControlViewModel;
  onValidate: InputOnValidate;
}

const ImageInputControl: React.FC<ImageInputControlProps> = ({
  control,
  onChange,
  onChanged,
  onValidate,
}) => {
  const props = pick(control, [
    'accept',
    'alt',
    'disabled',
    'height',
    'maxSizeMB',
    'name',
    'objectFit',
    'predefinedValue',
    'required',
    'value',
  ]);

  const validationProps = pick(control, ['name', 'required', 'value']);

  const { errors } = useLiveValidation({
    ...validationProps,
    requireDetectionStrategy: isEmpty,
    onValidate,
  });

  return (
    <ImageInput
      {...props}
      invalid={control.invalid || errors > 1}
      readOnly={control.readonly}
      onChange={onChange}
      onChanged={onChanged}
    />
  );
};

export default ImageInputControl;
